import { render } from "./App.vue?vue&type=template&id=3b1c0e0e"
const script = {}

import exportComponent from "D:\\1.starshine\\1.code\\1.using\\privacy_declare\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__